"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.watermarksMap = void 0;
const watermarks = __importStar(require("./images/watermarks"));
exports.watermarksMap = {
    behave: {
        light: watermarks.BehaveLight,
        dark: watermarks.BehaveDark
    },
    envestnet: {
        light: watermarks.EnvestnetLight,
        dark: watermarks.EnvestnetDark
    },
    finology: {
        light: watermarks.FinologyLight,
        dark: watermarks.FinologyDark
    },
    'first-clearing': {
        light: watermarks.FirstClearingLight,
        dark: watermarks.FirstClearingDark
    },
    flyer: {
        light: watermarks.FlyerLight,
        dark: watermarks.FlyerDark
    },
    'future-vault': {
        light: watermarks.FutureVaultLight,
        dark: watermarks.FutureVaultDark
    },
    greenhill: {
        light: watermarks.GreenhillLight,
        dark: watermarks.GreenhillDark
    },
    hubspot: {
        light: watermarks.HubspotLight,
        dark: watermarks.HubspotDark
    },
    invent: {
        light: watermarks.InventLight,
        dark: watermarks.InventDark
    },
    lodas: {
        light: watermarks.LodasLight,
        dark: watermarks.LodasDark
    },
    morningstar: {
        light: watermarks.MorningstarLight,
        dark: watermarks.MorningstarDark
    },
    redtail: {
        light: watermarks.RedtailLight,
        dark: watermarks.RedtailDark
    },
    salesforce: {
        light: watermarks.SalesforceLight,
        dark: watermarks.SalesforceDark
    },
    allianz: {
        light: watermarks.AllianzLight,
        dark: watermarks.AllianzDark
    },
    outlook: {
        light: watermarks.OutlookLight,
        dark: watermarks.OutlookDark
    },
    mfiles: {
        light: watermarks.MFilesLight,
        dark: watermarks.MFilesDark
    },
    addepar: {
        light: watermarks.AddeparLight,
        dark: watermarks.AddeparDark
    },
    msentra: {
        light: watermarks.MsentraLight,
        dark: watermarks.MsentraDark
    },
    nitrogen: {
        light: watermarks.NitrogenLight,
        dark: watermarks.NitrogenDark
    }
};
